import { DeckCard } from '@21st-night/deck';
import dayjs from 'dayjs';

export function getCardsCreatedOnDay(
  date: Date,
  cards: DeckCard[],
): DeckCard[] {
  return cards.filter(card => dayjs(card.createdAt).isSame(date, 'date'));
}
